import React, { createContext, useState, useCallback, useEffect } from "react";
import { createBrowserHistory } from "history";
import ReactGA from "react-ga";
import axios from "axios";

import config from "../dashboard-config";

ReactGA.initialize(config.googleAnalyticsTrackingNumber);
const browserHistory = createBrowserHistory();
browserHistory.listen((location, action) => {
  ReactGA.pageview(location.pathname + location.search);
});

export const SessionContext = createContext();

export const SessionContextProvider = props => {
  let defaultLoggedIn = false;
  const { username, token } = JSON.parse(
    localStorage.getItem("sofar-user") || "{}"
  );
  if (username && token) {
    defaultLoggedIn = true;
  }

  const [currentSession, setCurrentSession] = useState({
    redirectAfterLogin: null,
    isLogged: defaultLoggedIn
  });

  // it doesn't make sense to put isAdmin in currentTrial state, but we will deprecate the whole SessionContext any way
  const [currentTrial, setCurrentTrial] = useState({
    hasNotStartedAPITrial: false,
    isAdmin: false
  });

  // TODO The `username` piece of state is not used anywhere
  const [userData, setUserData] = useState({ username, token });

  const setToken = useCallback(
    newToken => {
      setUserData({ ...userData, token: newToken });
    },
    [userData]
  );

  // TODO: This state does not belong in this context
  const [selectedApiCard, setSelectedApiCard] = useState({
    section: null,
    selectedIndex: null
  });

  // TODO: Factor these fetch functions and the state they manage out
  // into custom hooks
  const fetchTrialStatus = async () => {
    try {
      const trialStatusResult = await axios.get(
        `${config.wavefleetUrl}/users/${username}`,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
            token: token
          }
        }
      );

      if (trialStatusResult.status === 200) {
        setCurrentTrial(c => ({
          ...c,
          hasNotStartedAPITrial: trialStatusResult.data.canStartFreeTrial,
          isAdmin: trialStatusResult.data.role === "admin"
        }));
      }
    } catch (e) {
      console.error("Could not fetch trial status:", e);
      setCurrentSession(s => ({ ...s, isLogged: false }));
    }
  };

  // Whenever the current session or user data info changes, query to find the user's trial status and admin status
  useEffect(() => {
    if (currentSession && currentSession.isLogged) {
      fetchTrialStatus();
    }
  }, [currentSession, userData]);

  return (
    <SessionContext.Provider
      value={{
        browserHistory,
        currentSession,
        setCurrentSession,
        currentTrial,
        userData,
        selectedApiCard,
        setCurrentTrial,
        setSelectedApiCard,
        setToken
      }}
    >
      {props.children}
    </SessionContext.Provider>
  );
};
